import EstoqueMovimentacaoService from "@/services/EstoqueMovimentacaoService";

export const estoqueMovimentacao = {
  namespaced: true,
  state: {
    estoqueMovimentacao: {},
  },
  actions: {
    getEstoqueMovimentacao({ commit }, payload) {
      return EstoqueMovimentacaoService.GetEstoqueMovimentacao(payload).then(
        (estoqueMovimentacao) => {
          return Promise.resolve(estoqueMovimentacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoqueMovimentacao({ commit }, payload) {
      return EstoqueMovimentacaoService.PostEstoqueMovimentacao(payload).then(
        (estoqueMovimentacao) => {
          return Promise.resolve(estoqueMovimentacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoqueMovimentacao({ commit }, payload) {
      return EstoqueMovimentacaoService.PutEstoqueMovimentacao(payload).then(
        (estoqueMovimentacao) => {
          return Promise.resolve(estoqueMovimentacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoqueMovimentacao({ commit }, payload) {
      return EstoqueMovimentacaoService.DeleteEstoqueMovimentacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueMovimentacaoOData({ commit }, payload) {
      return EstoqueMovimentacaoService.GetEstoqueMovimentacaoOData(
        payload
      ).then(
        (estoqueMovimentacao) => {
          return Promise.resolve(estoqueMovimentacao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoqueMovimentacao;
